import { RemoteConfigState } from './remote-config.types';

export const createRemoteConfigSlice = (): RemoteConfigState => ({
  remoteConfigData: null,
});
